export const defaultDisplayColumnsConfig = [
  'click_num',
  'cost',
  'show_num',
  'filled_rate',
  'ctr',
  'ecpm',
  'acp',
  'served_account_num',
  'new_account_num',
  'gain'
];
